export const initialSelectionState = {
  selectAll: false,
  total: 0,
  count: 0,
  excluded: {},
  included: {}
}

export const initialModelInfoState = {
  translations: [],
  defaultValues: {},
  sortingFields: {},
  pivotMode: undefined,
  itemPerPage: undefined,
  detailItemsPerPage: undefined
}

export const initialDocumentState = {
  documentsById: {},
  editedDocuments: [],
  latestEdit: null,
  selection: { ...initialSelectionState },
  editedModelInfo: { ...initialModelInfoState }
}

export const initialLinkedDocumentsState = {
  _uriKeys_: [],
  documentsByUri: {}
}
